import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const TABLE_HEADER_ROW_CELL_CLASS_NAME = 'TableHeaderRowCell';

export const TABLE_HEADER_ROW_CELL_CLASS_SLOTS = [
	'root',
	'content',
	'sortIcon',
] as const;

export type TableHeaderRowCellClassSlot =
	(typeof TABLE_HEADER_ROW_CELL_CLASS_SLOTS)[number];

export interface TableHeaderRowCellClasses {
	root: string;
	content: string;
	sortIcon: string;

	isResizing: string;
	isSorted: string;
	isSortable: string;
	sortedAsc: string;
	sortedDesc: string;
	sortTypeAlphanumeric: string;
	sortTypeNumeric: string;
}

export type TableHeaderRowCellClassKey = keyof TableHeaderRowCellClasses;

export const getTableHeaderRowCellUtilityClass = (slot: string) =>
	generateUtilityClass(TABLE_HEADER_ROW_CELL_CLASS_NAME, slot);

export const tableHeaderRowCellClasses = generateUtilityClasses<
	keyof TableHeaderRowCellClasses
>(TABLE_HEADER_ROW_CELL_CLASS_NAME, [
	'root',
	'content',
	'sortIcon',
	'isResizing',
	'isSorted',
	'isSortable',
	'sortedAsc',
	'sortedDesc',
	'sortTypeAlphanumeric',
	'sortTypeNumeric',
]);
export default tableHeaderRowCellClasses;
